import { Section, Eyebrow } from "./Section"

// Client logos pulled from the previous fullcast.co site, hosted in /public/logos.
const LOGOS = [
  { src: "/logos/claremont.png", alt: "Claremont Graduate University" },
  { src: "/logos/dun-bradstreet.png", alt: "Dun & Bradstreet" },
  { src: "/logos/k-swiss.png", alt: "K-Swiss" },
  { src: "/logos/mediamath.png", alt: "MediaMath" },
]

export function Proof() {
  return (
    <Section className="bg-surface">
      <div className="max-w-2xl">
        <Eyebrow>Proof</Eyebrow>
        <h2 className="display-2 mt-4">A decade of building shows that build trust</h2>
        <p className="mt-5 text-lg text-ink-body">
          Since 2015, FullCast has launched more than 130 podcasts for
          founder-led and expert-led brands — built on the relationship-driven
          approach Harry has practiced on his own shows since 2014.
        </p>
      </div>

      <p className="mt-10 text-sm font-medium uppercase tracking-wide text-ink-muted">
        Trusted by leaders at
      </p>
      <div className="mt-4 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-hairline bg-hairline sm:grid-cols-4">
        {LOGOS.map((logo) => (
          <div
            key={logo.alt}
            className="flex h-24 items-center justify-center bg-white p-6"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-h-10 w-auto max-w-full object-contain opacity-70 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </Section>
  )
}
